import gql from "graphql-tag";

import {type GqlFetchFn} from "@khan/data-gql";
import {gqlOp, type GqlOperation} from "@khan/data-gql-core";

import type {checkUsernameType} from "./__graphql-types__/index.ts";

export const CHECK_USERNAME_QUERY: GqlOperation<
    checkUsernameType["response"],
    checkUsernameType["variables"]
> = gqlOp(gql`
    query checkUsername($username: String!) {
        checkUsername(username: $username) {
            error {
                code
            }
        }
    }
`);

export type CheckUsernameError =
    | "TOO_SHORT"
    | "BAD_CHARACTERS"
    | "UNAVAILABLE"
    | "INTERNAL";

export const checkUsernameQuery = (gqlFetch: GqlFetchFn, username: string) =>
    gqlFetch(CHECK_USERNAME_QUERY, {
        variables: {username: username},
    });
